import store from './redux/store';
import * as chatActions from './modules/chat/app/ChatApp/actions';

const onFocus = () => {
  store.dispatch(chatActions.handleUpdateActiveSessionSeen());
};

export default function register() {
  // check for Internet Explorer
  // eslint-disable-next-line no-constant-condition, spaced-comment
  if (/*@cc_on!@*/ false) {
    document.onfocusin = onFocus;
  } else {
    window.onfocus = onFocus;
  }
}
